import { useEffect, useState } from "react";
import PostCard from "../../../components/Blogs/PostCard/Post_Card";
import useContentful from "../../../hooks/useContentfull";
import "./Blog_list.css";
import Spinner from "../../../components/Ui/Spinner/Spinner";
import { Alert } from "@mui/material";
import FadeIn from "../../../animations/components/FadeIn/FadeIn";
import LoadingSpinner from "../../../animations/components/LoadingSpinner/LoadingSpinner";
import ResponsiveContainer from "../../../responsive/components/ResponsiveContainer/ResponsiveContainer";

const Blog_List = () => {
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const { getPosts } = useContentful();

    useEffect(() => {
        const fetchPosts = async () => {
            try {
                setLoading(true);
                const posts = await getPosts();
                setPosts(posts || []);
            } catch (err) {
                console.error("Error fetching posts:", err);
                setError("Failed to load posts. Please try again later.");
            } finally {
                setLoading(false);
            }
        };

        fetchPosts();
    }, []);

    return (

        <div className="blog-list">
            <FadeIn className="blog-list-header" delay={0.4}>
                <h1 className="blog-list-title">Recent Articles</h1>
            </FadeIn>

            <ResponsiveContainer>
                <div className="blog-list-content">
                    {loading ? (
                        <LoadingSpinner />
                    ) : error ? (
                        <div className="error-message">
                            <Alert severity="error">{error}</Alert>
                        </div>
                    ) : posts.length === 0 ? (
                        <div className="empty-message">
                            <p>No blog posts available yet. Check back soon!</p>
                        </div>
                    ) : (
                        <div className="blog-cards">
                            {posts.map((post) => (
                                <FadeIn key={post.id} delay={0.4}>
                                    <PostCard post={post} />
                                </FadeIn>

                            ))}
                        </div>
                    )}
                </div>
            </ResponsiveContainer>
        </div>
    );
};

export default Blog_List